import { render, staticRenderFns } from "./GoodTable.vue?vue&type=template&id=3d4175ac&scoped=true"
import script from "./GoodTable.vue?vue&type=script&lang=js"
export * from "./GoodTable.vue?vue&type=script&lang=js"
import style0 from "./GoodTable.vue?vue&type=style&index=0&id=3d4175ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4175ac",
  null
  
)

export default component.exports